<template lang="html">
<div class="model-back" v-if="state">
     <div :class="['app-model',modelClass]">
          <div class="model-head">提示</div>
          <div class="model-content">
                {{modelText}}
          </div>
          <div class="model-btns">
               <div class="model-btn" @click="hide">取消</div>
               <div class="btn-line"></div>
               <div class="model-btn" @click="toLogin">确定</div>
          </div>
     </div>
</div>
</template>

<script>

import vEmits from "@/utils/vEmits";

export default {

    data(){
        return{
             state:'',
             modelClass:'',
             modelText:''
        }
    },

    methods:{

        show:function(e){
            this.state = 'show';
            this.modelClass = 'show';
            this.modelText = e;
        },
        hide:function(){
            let vues = this;
            this.modelClass = 'hide';
            if(this.wait){
               clearTimeout(this.wait);
            }
            this.wait = setTimeout(function(){
               vues.state = '';
               vues.modelText = '';
               vues.modelClass = '';
            },100)
        },
        toLogin:function(){
            this.hide();
            this.push('login');
        }

    },

    mounted:function(){

        let vues = this;
        vEmits.$on('showModel',function(e){
            vues.show(e);
        })

        vEmits.$on('hideModel',function(){
            vues.hide();
        })

    }

}

</script>

<style lang="css" scoped>

.model-back{
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app-model{
    position: relative;
    width: 80%;
    background: white;
}

.app-model.show{
    animation-name: show;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
}

@-webkit-keyframes show{
    0%{
         -webkit-transform:scale(0.9);
         opacity: 0;
    }
    100%{
        -webkit-transform:scale(1);
        opacity: 1;
    }
}

.app-model.hide{
    animation-name: hide;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
}

@-webkit-keyframes hide{
    0%{
        -webkit-transform:scale(1);
        opacity: 1;
    }
    100%{
        -webkit-transform:scale(0.9);
        opacity: 0;
    }
}

.model-head{
    padding-top: 12px;
    text-align: center;
}

.model-content{
    padding: 18px 12px;
    min-height: 30px;
    text-align: center;
    border-bottom: 1px solid #efefef;
}

.model-btns{
    display: flex;
}

.btn-line{
    height: 42px;
    width: 1px;
    background: #efefef;
}

.model-btn{
    flex-grow: 1;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
}



</style>
